import {
	dangerColor,
	successColor,
	defaultBodyFont,
	whiteColor,
	blackColors,
	formElementColors,
	grayColor,
	dark_grey_1,
} from 'assets/jss/material-dashboard-pro-react';

const customInputStyle = (theme) => {
	const colors = {
		focus: theme.palette.primary.main,
		success: successColor[0],
		error: dangerColor[0],
		hover: blackColors[2],
	};

	return {
		disabled: {
			'&:before': {
				borderColor: `${blackColors[4]} !important`,
			},
		},
		underline: {
			'&:hover:not($disabled):before,&:before': {
				borderColor: blackColors[3],
				borderWidth: '1px',
			},
			'&$disabled:before,&$disabled:after': {
				borderBottomStyle: 'solid',
			},
			'&:after': {
				borderColor: `${colors.focus} !important`,
				borderWidth: '2px !important',
			},
			'& + p': {
				fontWeight: 'normal',
			},
		},
		underlineError: {
			'&:before': {
				borderColor: `${colors.error} !important`,
				borderWidth: '2px !important',
			},
			'&:after': {
				borderColor: `${colors.error} !important`,
				borderWidth: '2px !important',
			},
		},
		underlineSuccess: {
			'&:before': {
				borderColor: `${colors.success} !important`,
				borderWidth: '2px !important',
			},
		},
		underlineNotEmpty: {
			'&:before,&:hover:before': {
				borderColor: `${colors.hover} !important`,
				borderWidth: '2px !important',
			},
		},
		labelRoot: {
			...defaultBodyFont,
			color: blackColors[2] + ' !important',
			fontSize: theme.fontSize(16),
			lineHeight: theme.direction === 'rtl' ? '20px' : 'inherit',
			top: theme.direction === 'rtl' ? 5 : 8,
			'& + $underline': {
				marginTop: '0px',
			},
			'&.MuiInputLabel-shrink': {
				fontSize: theme.fontSize(14),
				transform: 'translate(0, 1.5px)',
			},
		},
		labelHover: {
			color: `${blackColors[1]} !important`,
			'&.Mui-focused': {
				color: `${colors.hover} !important`,
			},
		},
		labelDisabled: {
			color: `${blackColors[3]} !important`,
		},
		formControlHover: {
			'& svg, & .material-icons': {
				color: `${colors.hover} !important`,
			},
		},
		formControlNotEmpty: {
			'& svg, & .material-icons': {
				color: `${colors.hover} !important`,
			},
		},
		formControlIcon: {
			'&.MuiFormControl-fullWidth': {
				width: 'calc(100% - 35px)',
			},
			'& svg': {
				height: 18,
			},
		},
		visibilityIcon: {
			marginRight: -12,
			'& svg': {
				color: `${blackColors[1]} !important`,
			},
		},
		icon: {
			width: 35,
			display: 'inline-block',
			marginTop: 'auto',
			marginBottom: 'auto',
			'& svg': {
				height: '18px',
				position: 'relative',
				top: 6,
				marginRight: 8,
				color: blackColors[3],
			},
		},
		iconSuccess: {
			'& svg': {
				color: `${colors.success}`,
			},
		},
		iconHover: {
			'& svg': {
				color: colors.hover,
			},
		},
		iconError: {
			'& svg': {
				color: colors.error,
			},
		},
		iconFocus: {
			'& svg': {
				color: colors.focus,
			},
		},
		formControl: {
			margin: '0 0 17px 0',
			paddingTop: '27px',
			position: 'relative',
			verticalAlign: 'unset',
			'& .fab,& .far,& .fal,& .fas, & svg, & .material-icons': {
				color: `${blackColors[3]}`,
			},
		},
		formControlFocus: {
			'& svg, & .material-icons': {
				color: `${colors.focus} !important`,
			},
		},
		formControlSuccess: {
			'& svg, & .material-icons': {
				color: `${colors.success} !important`,
			},
		},
		formControlError: {
			'& svg, & .material-icons': {
				color: `${colors.error} !important`,
			},
		},
		whiteUnderline: {
			'&:hover:not($disabled):before,&:before': {
				backgroundColor: whiteColor,
			},
			'&:after': {
				backgroundColor: whiteColor,
			},
		},
		input: {
			color: blackColors[1],
			height: 'unset',
			...(theme.direction === 'rtl'
				? {
						padding: '0 0 3px 0',
				  }
				: {}),
			'&,&::placeholder': {
				fontSize: 'inherit',
				fontFamily: 'inherit',
				fontWeight: 'normal',
				opacity: '1',
			},
			'&::placeholder': {
				color: blackColors[3],
			},

			'&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
				'-webkit-appearance': 'none',
				margin: 0,
			},
			'-moz-appearance': 'textfield',
			'&::-ms-reveal': {
				display: 'none',
			},
			'&::-ms-clear': {
				display: 'none',
			},
		},
		whiteInput: {
			'&,&::placeholder': {
				color: whiteColor,
				opacity: '1',
			},
		},
		hideArrows: {
			'-moz-appearance': 'textfield',
			'&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
				'-webkit-appearance': 'none',
			},
		},
		helperText: {
			...defaultBodyFont,
			fontSize: theme.direction === 'rtl' ? 16 : theme.fontSize(12),
			lineHeight: theme.direction === 'rtl' ? '20px' : 'inherit',
			marginTop: theme.direction === 'rtl' ? '4px' : '6px',
		},
		helperTextError: {
			color: colors.error,
		},
		helperTextSuccess: {
			color: colors.success,
		},
		helperTextDisabled: {
			color: `${blackColors[3]} !important`,
		},
		inputWrapper: {
			alignItems: 'center',
		},
		placeholderAdornment: {
			position: 'absolute',
			pointerEvents: 'none',
			color: dark_grey_1,
			left: 12,
		},
		newThemedInput: {
			'& label': {
				transform: 'translate(0, -0.5rem) !important',
				color: `${formElementColors.label} !important`,
			},
			'& > div': {
				border: `1px solid ${grayColor[0]}`,
				background: formElementColors.bg,
				paddingLeft: 0,
				'& fieldset': {
					border: 'none',
				},
			},
			'& > div input': { ...defaultBodyFont, height: '3rem', padding: '0 0.75rem' },
		},
	};
};

export default customInputStyle;
